import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EmptyStateBox } from '../../../../components';
import { NavHeader } from '../../../../components/nav-header';
import { Page } from '../../../../components/page';
import { ROUTES } from '../../../../routes/routes';

const NotificationNotFound: React.FC = () => {
  const { t } = useTranslation('notifications');
  const navigate = useNavigate();

  const handleBack = () => navigate(ROUTES.Root());

  return (
    <Page isStickyHeader header={<NavHeader onClick={handleBack} />}>
      <EmptyStateBox content={t('notificationNotFound')} />
    </Page>
  );
};

export default NotificationNotFound;
